import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Typography
} from '@material-ui/core';

import HoursMinutesPicker from '../../../../common/components/UI/HoursMinutesPicker/HoursMinutesPicker';
import NumericInput from '../../../../common/components/UI/Input';
import {
    generateToggle,
    HoursMinutesPickerStyles,
} from './Form.service';

function PartialShiftSection({
    classes, isShow: isShowPartialShiftSection, isToCover, isShiftSwap, isOpenShift, onChange = () => { }, handleChangeEnablePartialShift = () => { },
    enablePartialShifts, multiplePartial, isAllowPartialOfPartial, minimumPartialShiftDuration, minimumPartialShiftBalanceDuration, isPartialOnlyOnEdges, isUsedAdminSetting,
    maxAllowedPartial,
}) {
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'form' });

    return (
        <>
            <div className={classes.containerLabelsFullWidth} hidden={!isShowPartialShiftSection}>
                <Typography className={classes.subHeader} color="textSecondary">{t('enablePartialShifts')}</Typography>
            </div>
            {
                generateToggle(
                    () => handleChangeEnablePartialShift(!enablePartialShifts),
                    enablePartialShifts,
                    t('enabled'),
                    t('disabled'),
                    `*${isOpenShift ? t('enableOpenShiftPartialShiftsDisclaimer') : t('enablePartialShiftsDisclaimer')}`,
                    !isShowPartialShiftSection,
                    "enablePartialShifts",
                    isUsedAdminSetting,
                )
            }
            <div
                className={classes.containerLabelsFullWidth}
                hidden={!isShowPartialShiftSection || !enablePartialShifts}
            >
                <div hidden={!(isToCover || isShiftSwap)}>
                    <Typography className={classes.subHeader} color="textSecondary" >{t('multiplePartial')}</Typography>
                    {
                        generateToggle(
                            () => onChange('multiplePartial', !multiplePartial),
                            multiplePartial,
                            t('enabled'),
                            t('disabled'),
                            '*' + t('multiplePartialDisclaimer'),
                            !(isToCover || isShiftSwap),
                            "multiplePartial",
                            !enablePartialShifts,
                        )
                    }
                    <Typography className={classes.subHeader} color="textSecondary" >{t('partialOfPartial')}</Typography>
                    {
                        generateToggle(
                            () => onChange('isAllowPartialOfPartial', !isAllowPartialOfPartial),
                            isAllowPartialOfPartial,
                            t('enabled'),
                            t('disabled'),
                            `*${isToCover ? t('partialOfToCoverPartialDisclaimer') : t('partialOfShiftSwapPartialDisclaimer')}`,
                            !(isToCover || isShiftSwap),
                            "isAllowPartialOfPartial",
                            !enablePartialShifts,
                        )
                    }
                </div>
                <HoursMinutesPicker
                    nbHours={Math.floor(minimumPartialShiftDuration / 60)}
                    nbMinutes={Math.abs(minimumPartialShiftDuration) % 60}
                    minuteStep={15}
                    minuteMax={45}
                    handleChange={(hours, minutes) => onChange('minimumPartialShiftDuration', hours * 60 + minutes)}
                    name="MinPartialDuration"
                    label={t('minimumPartialShiftDuration')}
                    smallLabels={true}
                    classes={classes}
                    hourFormat={(num) => {
                        if (+num === 1) {
                            return num + ' Hour';
                        }
                        else {
                            return num + ' Hours';
                        }
                    }}
                    minuteFormat={(num) => {
                        if (+num === 1) {
                            return num + ' Minute';
                        }
                        else {
                            return num + ' Minutes';
                        }
                    }}
                    style={HoursMinutesPickerStyles}
                />
                <HoursMinutesPicker
                    nbHours={Math.floor(minimumPartialShiftBalanceDuration / 60)}
                    nbMinutes={Math.abs(minimumPartialShiftBalanceDuration) % 60}
                    minuteStep={15}
                    minuteMax={45}
                    handleChange={(hours, minutes) => onChange('minimumPartialShiftBalanceDuration', hours * 60 + minutes)}
                    name="MinPartialShiftBalanceDuration"
                    label={t('minimumPartialShiftBalanceDuration')}
                    smallLabels={true}
                    classes={classes}
                    hourFormat={(num) => {
                        if (num === 1) {
                            return num + ' Hour';
                        }
                        else {
                            return num + ' Hours';
                        }
                    }}
                    minuteFormat={(num) => {
                        if (num === 1) {
                            return num + ' Minute';
                        }
                        else {
                            return num + ' Minutes';
                        }
                    }}
                    style={HoursMinutesPickerStyles}
                />
                <p>
                    <small className={classes.note}>
                        {`*${isOpenShift ? t('minimumPartialOpenShiftBalanceDurationDisclaimer') : t('minimumPartialShiftBalanceDurationDisclaimer')}`}
                    </small>
                </p>
                <div className={classes.containerLabelsFullWidth} style={{ marginBottom: '1rem' }} hidden={!(isToCover || isShiftSwap)}>
                    <Typography className={classes.subHeader} style={{ marginBottom: '-8px' }} color="textSecondary">Number of maximum allowed partial requests on the same shift</Typography>
                    <div className={classes.containerOverlappingTc}>
                        <NumericInput
                            min={0} max={99} step={1} precision={0}
                            value={maxAllowedPartial}
                            strict={true}
                            handleChangeInput={(value) => onChange('maxAllowedPartial', value)}
                            style={{ input: { width: '42px' } }}
                        />
                        <small className={classes.formControlLabel}>If 0, no limit will be applied</small>
                    </div>
                </div>
                <div>
                    <Typography className={classes.subHeader} color="textSecondary" >{t(`${isOpenShift ? 'isPartialOnlyOnEdgesOpenShift' : 'isPartialOnlyOnEdgesToCover'}`)}</Typography>
                    {
                        generateToggle(
                            () => onChange('isPartialOnlyOnEdges', !isPartialOnlyOnEdges),
                            isPartialOnlyOnEdges,
                            t('enabled'),
                            t('disabled'),
                            '*' + t(`${isOpenShift ? 'isPartialOnlyOnEdgesOpenShiftDisclaimer' : 'isPartialOnlyOnEdgesDisclaimer'}`),
                            false,
                            "isPartialOnlyOnEdges",
                            !enablePartialShifts,
                        )
                    }
                </div>
            </div>
        </>

    )
}

export default PartialShiftSection;
